<template>
  <div class="content-page">
    <div class="bd">
      <div class="content">
        <div class="content-container">
          <el-form ref="form" label-position="right" label-width="180px">
            <el-form-item label="提货点：">
              <div class="form-inline-content">
                <div class="select-address">
                  <el-select v-model="selShopAddress" placeholder="请选择">
                    <el-option
                      v-for="(item, index) in shopAddressList"
                      :key="index"
                      :label="item.address"
                      :value="index"
                    >
                    </el-option>
                  </el-select>
                  <el-button type="primary" @click="addNew">新增</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="联系人：">
              <div class="form-inline-content">
                <div class="name">
                  <el-input
                    v-model="shopAddressForm.name"
                    :maxlength="10"
                    placeholder="请填写联系人"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="联系电话：">
              <div class="form-inline-content">
                <div class="phone">
                  <el-input
                    v-model="shopAddressForm.phone"
                    placeholder="请填写联系电话"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="所在地：">
              <div class="form-inline-content">
                <div class="cityName">
                  <el-cascader
                    v-model="shopAddressForm.cityName"
                    @change="cityNameCascaderHandler"
                    :options="cityOptions"
                    :props="{ expandTrigger: 'hover', value: 'value' }"
                    placeholder="请选择门店所在地"
                  ></el-cascader>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="详细地址：">
              <div class="form-inline-content">
                <div class="shopAddress">
                  <el-input
                    v-model="shopAddressForm.address"
                    placeholder="请填写店铺地址"
                  >
                    <!-- <template slot="append">
                      <el-button @click="showDialogMap">去定位</el-button>
                    </template> -->
                  </el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="经纬度:" prop="center">
              <div class="form-inline-content">
                <div class="shopAddress">
                  <el-input
                    v-model="mapCenterInputText"
                    placeholder="请填写经纬度"
                    @blur="mapCenterInputTextBlur(shopAddressForm)"
                  >
                    <template slot="append">
                      <el-button type="primary" @click="showDialogMap()"
                        >去获取</el-button
                      >
                    </template>
                  </el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="地址补充：">
              <div class="form-inline-content">
                <div class="phone">
                  <el-input v-model="shopAddressForm.doorNum" :maxlength="30"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item class="submit-btn-container">
              <el-button
                v-show="shopAddressForm.isVerified != 1 && selShopAddress != '新增'"
                type="success"
                @click="editShopAddress('verified')"
                >审核通过</el-button
              >
              <el-button type="primary" @click="submitForm">保存</el-button>
              <el-button
                type="danger"
                @click="delShopAddress"
                :disabled="shopAddressList.length == 0 ? true : false"
                >删除</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
      width="510px"
      :visible.sync="dialogMapVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <div slot="title" class="dialog-title">地图定位</div>
      <!-- <baidu-map
        v-if="dialogMapVisible"
        class="map"
        :center="center"
        :zoom="zoom"
        @ready="mapReadyHandler"
        @click="getPoint"
        :scroll-wheel-zoom="true"
      >
        <bm-control :offset="{ width: '10px', height: '10px' }">
          <el-input v-model="keyword" placeholder="请输入地名关键字"></el-input>
        </bm-control>
        <bm-local-search
          :keyword="keyword"
          :auto-viewport="true"
          :location="location"
          zoom="12.8"
          style="display: none"
        ></bm-local-search>
        <bm-marker :position="postionMap">
          <bm-info-window
            :show="show"
            @close="infoWindowClose"
            @open="infoWindowOpen"
            style="font-size: 14px"
          >
            <p>站点：{{ add.siteName }}</p>
            <p>站点地址：{{ add.site }}</p>
          </bm-info-window>
        </bm-marker>
      </baidu-map> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveStationAddress">保存</el-button>
      </div>
    </el-dialog>
    <!-- <baidu-map v-if="showMap" class="index-map"></baidu-map> -->
  </div>
</template>

<script>
import {
  getShopAddressList,
  addShopAddress,
  editShopAddress,
  delShopAddress,
} from "@/api";
import { commonFuc } from "@/mixins/commonFuc";
import { gg2bd, bd2gg } from "@/utils/map.js";

export default {
  mixins: [commonFuc],
  data() {
    return {
      cityOptions: require("@/assets/js/cityData.json"),
      mapCenter: "",
      center: { lng: 0, lat: 0 },
      zoom: 12.8,
      dialogMapVisible: false,
      keyword: "",
      location: "",
      show: false,
      postionMap: {
        //地图坐标
        lng: 120.211486,
        lat: 30.256576,
      },
      add: {
        siteName: "",
        site: "",
        jd: "",
        wd: "",
        desce: "",
        type: "",
        jgName: "",
        jgNum: "",
      },
      showMap: false,
      // 配送点配置
      selShopAddress: "",
      shopAddressList: [],
      shopAddressForm: {
        shopAddressId: "",
        name: "",
        phone: "",
        cityName: [],
        address: "",
        doorNum: "",
        longitude: "",
        latitude: "",
        cityId: "",
        districtId: "",
        provinceId: "",
        isVerified: "",
      },
    };
  },
  props: {
    status: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    selShopAddress(val) {
      if (isNaN(val)) {
        return;
      }
      this.showMap = true;
      setTimeout(() => {
        this.showMap = false;
        let { lng, lat } = gg2bd(
          this.shopAddressList[val].longitude,
          this.shopAddressList[val].latitude
        );
        this.mapCenterInputText = `${this.shopAddressList[val].longitude},${this.shopAddressList[val].latitude}`;
        this.shopAddressForm.name = this.shopAddressList[val].name;
        this.shopAddressForm.phone = this.shopAddressList[val].phone;
        this.shopAddressForm.address = this.shopAddressList[val].address;
        this.shopAddressForm.doorNum = this.shopAddressList[val].doorNum;
        this.shopAddressForm.provinceId = this.shopAddressList[val].provinceId;
        this.shopAddressForm.cityId = this.shopAddressList[val].cityId;
        this.shopAddressForm.districtId = this.shopAddressList[val].districtId;
        this.shopAddressForm.shopAddressId = this.shopAddressList[val].shopAddressId;
        this.shopAddressForm.isVerified = this.shopAddressList[val].isVerified;
        this.shopAddressForm.cityName = this.shopAddressList[val].areaJson
          ? JSON.parse(this.shopAddressList[val].areaJson)
          : [];
        let cityName = "";
        let value = this.shopAddressForm.cityName;
        cityName += this.cityOptions[value[0] - 1].label;
        this.cityOptions[value[0] - 1].children.forEach((val) => {
          if (val.value == value[1]) {
            cityName += val.label;
            val.children.forEach((subval) => {
              if (subval.value == value[2]) {
                cityName += subval.label;
              }
            });
          }
        });
        this.mapCenter = cityName;
        this.$forceUpdate();
        // let point = new BMap.Point(lng, lat);
        // let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
        // geocoder.getLocation(point, (rs) => {
        // });
      }, 500);
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData(index = "") {
      this.getShopAddressList(index);
    },
    getShopAddressList(index) {
      getShopAddressList({
        edcShopId: localStorage.shopId,
        pageNo: 1,
        row: 999,
      }).then((res) => {
        if (res.code == 1) {
          this.shopAddressList = res.data;
          if (this.shopAddressList.length && !index) {
            this.selShopAddress = 0;
          } else {
            this.selShopAddress = index;
          }
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
          this.selShopAddress = "新增";
          this.shopAddressForm = {};
        }
      });
    },
    addNew() {
      this.shopAddressForm = {
        shopAddressId: "",
        name: "",
        phone: "",
        cityName: [],
        address: "",
        doorNum: "",
        longitude: "",
        latitude: "",
        cityId: "",
        districtId: "",
        provinceId: "",
        isVerified: "",
      };
      this.selShopAddress = "新增";
    },
    cityNameCascaderHandler(value) {
      this.shopAddressForm.provinceId = value[0];
      this.shopAddressForm.cityId = value[1];
      this.shopAddressForm.districtId = value[2] || -1;
      let cityName = "";
      cityName += this.cityOptions[value[0] - 1].label;
      this.cityOptions[value[0] - 1].children.forEach((val) => {
        if (val.value == value[1]) {
          cityName += val.label;
          if (val.children) {
            val.children.forEach((subval) => {
              if (subval.value == value[2]) {
                cityName += subval.label;
              }
            });
          }
        }
      });
      this.mapCenter = cityName;
    },
    // showDialogMap() {
    //   if (!this.shopAddressForm.cityName) {
    //     this.$notify({
    //       title: "警告",
    //       message: "请先选择城市",
    //       type: "warning",
    //       duration: 6000,
    //     });
    //     return;
    //   }
    //   this.dialogMapVisible = true;
    // },
    mapReadyHandler({ BMap, map }) {
      this.center = this.mapCenter;
      this.zoom = 12.8;
    },
    saveStationAddress() {
      this.dialogMapVisible = false;
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      setInterval(() => {
        this.show = true;
      }, 100);
    },
    getPoint(e) {
      //点击地图获取一些信息，
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();

      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, (rs) => {
        this.add.site = rs.address;
        this.add.lng = rs.point.lng;
        this.add.lat = rs.point.lat;
        this.shopAddressForm.address = rs.address;
        let { lng, lat } = bd2gg(rs.point.lng, rs.point.lat);
        this.shopAddressForm.longitude = lng;
        this.shopAddressForm.latitude = lat;
      });
    },
    addShopAddress() {
      if (!this.shopAddressForm.cityId) {
        this.$message.error("请选择所在地");
        return;
      }
      addShopAddress({
        address: this.shopAddressForm.address,
        cityId: this.shopAddressForm.cityId,
        districtId: this.shopAddressForm.districtId,
        doorNum: this.shopAddressForm.doorNum,
        latitude: this.shopAddressForm.latitude,
        longitude: this.shopAddressForm.longitude,
        provinceId: this.shopAddressForm.provinceId,
        name: this.shopAddressForm.name,
        phone: this.shopAddressForm.phone,
        areaJson: JSON.stringify(this.shopAddressForm.cityName),
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "新增成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    editShopAddress(type = "") {
      if (!this.shopAddressForm.cityId) {
        this.$message.error("请选择所在地");
        return;
      }
      editShopAddress({
        shopAddressId: this.shopAddressForm.shopAddressId,
        address: this.shopAddressForm.address,
        cityId: this.shopAddressForm.cityId,
        districtId: this.shopAddressForm.districtId,
        doorNum: this.shopAddressForm.doorNum,
        latitude: this.shopAddressForm.latitude,
        longitude: this.shopAddressForm.longitude,
        provinceId: this.shopAddressForm.provinceId,
        name: this.shopAddressForm.name,
        phone: this.shopAddressForm.phone,
        areaJson: JSON.stringify(this.shopAddressForm.cityName),
        isVerified: type == "verified" ? 1 : "",
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: type == "verified" ? "审核通过" : "保存成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData(0);
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    delShopAddress() {
      delShopAddress({
        shopAddressId: this.shopAddressForm.shopAddressId,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "删除成功",
            type: "success",
            duration: 1000,
          });
          this.shopAddressList = [];
          this.selShopAddress = "";
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    submitForm() {
      if (this.selShopAddress == "新增") {
        this.addShopAddress();
      } else {
        this.editShopAddress();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .bd {
    height: 100%;
    padding: 20px;
    .content-container {
      padding-top: 20px;
      .el-input,
      .el-cascader,
      .el-select {
        width: 300px;
      }
      .select-address {
        .el-button {
          margin-left: 10px;
        }
      }
    }
  }
}
.map {
  width: 100%;
  height: 400px;
  　　/deep/ .anchorBL {
    display: none;
  }
}
</style>
